import { useBoolean } from 'ahooks';
import classNames from 'classnames';
import { EditJsonModal } from '../../../EditJsonModal';

export const EditJsonButton = ({
  json,
  onChange,
  readOnly,
}: {
  json: Record<string, unknown> | unknown[];
  onChange: (json: Record<string, unknown> | unknown[]) => void;
  readOnly: boolean;
}) => {
  const [open, setOpen] = useBoolean();

  const changeValue = (value: string) => {
    onChange(JSON.parse(value));
    setOpen.setFalse();
  };
  return (
    <>
      <span
        className={classNames(
          'underline whitespace-nowrap',
          !readOnly && 'cursor-pointer'
        )}
        onClick={readOnly ? undefined : setOpen.setTrue}
      >
        Edit JSON data
      </span>
      <EditJsonModal
        open={open}
        value={JSON.stringify(json)}
        onCancel={setOpen.setFalse}
        onSubmit={changeValue}
      />
    </>
  );
};
